export const SEND_SEARCH_PARAMETERS = 'SEND_SEARCH_PARAMETERS';
export type SEND_SEARCH_PARAMETERS = typeof SEND_SEARCH_PARAMETERS;

export const SEND_HIDE_QUERY = 'SEND_HIDE_QUERY';
export type SEND_HIDE_QUERY = typeof SEND_HIDE_QUERY;